import React from "react";
import DroppableCell from "./DroppableCell.js";
import { chunk, coachMatchesStudentAssignment, isCoachAvailable } from "./utils.js";

const DayView = ({
  selectedDay,
  filteredCoaches,
  students,
  coaches,
  moveStudent,
  setAddingStudent,
  setDisplayedStudentName,
  setSelectedStudentToAdd,
  onManageStudent,
  hours,
}) => {
  const visibleCoaches = filteredCoaches.slice(0, 3);
  const BASE_COLUMNS = 6;
  const slotsPerCoach = Math.max(
    1,
    Math.floor(BASE_COLUMNS / Math.max(1, visibleCoaches.length))
  );
  const hourRows = chunk(hours, slotsPerCoach);

  return (
    <div className="coach-schedule-dynamic">
      <div
        className="coach-header"
        style={{
          gridTemplateColumns: `repeat(${Math.max(
            1,
            visibleCoaches.length
          )}, minmax(180px, 1fr))`,
        }}
      >
        {visibleCoaches.length === 0 && (
          <div className="no-coach">Keine Trainer</div>
        )}
        {visibleCoaches.map((coach) => (
          <div
            className="coach-col-header"
            key={coach._id}
            title={`${coach.firstName} ${coach.lastName}`}
          >
            <strong>
              {coach.firstName} {coach.lastName}
            </strong>
          </div>
        ))}
      </div>

      {hourRows.map((hourChunk, rowIdx) => (
        <div
          className="coach-hour-row"
          key={`hourrow-${rowIdx}`}
          style={{
            gridTemplateColumns: `repeat(${Math.max(
              1,
              visibleCoaches.length
            )}, minmax(180px, 1fr))`,
          }}
        >
          {visibleCoaches.map((coach, coachIndex) => {
            const coachName = `${coach.firstName} ${coach.lastName}`;
            const coachKey =
              coach._id || `${coach.firstName}-${coach.lastName}`;

            return (
              <div
                className="coach-column"
                key={`${coachKey}-row-${rowIdx}`}
              >
                <div className="hour-slot-group">
                  {hourChunk.map((hour) => {
                    // Filter students using assignments array (supports multiple assignments)
                    const studentsInCell = students.filter((s) => {
                      if (!s) return false;

                      // Check if student has assignments array (new format)
                      let isAtThisSlot = false;
                      if (Array.isArray(s.assignments) && s.assignments.length > 0) {
                        isAtThisSlot = s.assignments.some((assignment) => {
                          return (
                            String(assignment.day).trim() === String(selectedDay).trim() &&
                            Number(assignment.hour) === hour
                          );
                        });
                      } else {
                        // Fall back to legacy fields for backward compatibility
                        if (String(s.day).trim() !== String(selectedDay).trim())
                          return false;
                        const sHour =
                          s.hour === null ||
                          s.hour === undefined ||
                          s.hour === ""
                            ? null
                            : Number(s.hour);
                        if (sHour !== hour) return false;
                        isAtThisSlot = true;
                      }

                      if (!isAtThisSlot) return false;
                      // Use new function that checks assignment coach for this specific day/hour
                      return coachMatchesStudentAssignment(coach, s, selectedDay, hour);
                    });

                    const available = isCoachAvailable(coach, selectedDay, hour);

                    return (
                      <div
                        className="hour-cell"
                        key={`${coachKey}-${hour}`}
                      >
                        <span className="hour-label">{hour}:00</span>
                        <DroppableCell
                          day={selectedDay}
                          hour={hour}
                          coach={coach}
                          coaches={coaches}
                          studentsInCell={studentsInCell}
                          isAvailable={available}
                          moveStudent={moveStudent}
                          setAddingStudent={setAddingStudent}
                          setDisplayedStudentName={setDisplayedStudentName}
                          setSelectedStudentToAdd={setSelectedStudentToAdd}
                          onManageStudent={onManageStudent}
                          columnIndex={coachIndex}
                          totalColumns={visibleCoaches.length}
                          aria-label={`Coach ${coachName} - ${hour}:00`}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default DayView;
